document.addEventListener('DOMContentLoaded', function() {

// 1. Detect currency from the store's HTML once
const priceElement = document.querySelector('.new-price, .product-item__price');
const currencyCode = priceElement && priceElement.textContent.includes('£') ? 'GBP' : 'EUR';

// 2. Professional browser-native formatter
const formatter = new Intl.NumberFormat('en-IE', {
style: 'currency',
currency: currencyCode,
currencyDisplay: 'symbol'
});

const productItems = document.querySelectorAll('[data-product-grid-item]');

productItems.forEach(function(productItem) {
const swatches = productItem.querySelectorAll('.var_metireal a');
const savingsBadge = productItem.querySelector('.custom-savings-badge');
const priceContainer = productItem.querySelector('[data-product-price]');
const hasSetDiscount = savingsBadge !== null;

// Remove "From" on load
if (swatches.length > 0) {
const fromText = productItem.querySelector('.new-price small');
if (fromText) fromText.remove();
}

if (swatches.length === 0) return;

swatches.forEach(function(swatch) {
swatch.addEventListener('click', function(e) {
e.preventDefault();
const wrapper = this.parentElement;
const price = parseInt(wrapper.getAttribute('data-variant-price'));
const compare = parseInt(wrapper.getAttribute('data-variant-compare-price'));
const img = wrapper.getAttribute('dataswatches');

// Update Image
const productImage = productItem.querySelector('[data-product-image-default] img');
if (productImage && img) productImage.src = img;

// Format prices (dividing by 100 for cents-to-units)
const formattedPrice = formatter.format(price / 100) + ' ' + currencyCode;
const formattedCompare = formatter.format(compare / 100) + ' ' + currencyCode;
const formattedSavings = formatter.format((compare - price) / 100);

// Update Savings Badge
if (hasSetDiscount && savingsBadge && compare > price) {
savingsBadge.textContent = 'Save ' + formattedSavings;
}

// Update Prices
if (priceContainer) {
const newPriceEl = priceContainer.querySelector('.new-price');
const oldPriceEl = priceContainer.querySelector('.old-price');

if (newPriceEl) newPriceEl.textContent = formattedPrice;

if (oldPriceEl && compare > price) {
const pct = Math.round(((compare - price) / compare) * 100);
oldPriceEl.innerHTML = formattedCompare + ' <span class="percent-off-badge">(' + pct + '%)</span>';
oldPriceEl.style.display = '';
} else if (oldPriceEl) {
oldPriceEl.style.display = 'none';
}
}
});
});
});
});